/**
 * Owner: Masa Bayu
 * File: security-baseline.ts
 * Date:Time: 2026-09-15 19:18
 * Description: QXRead T0 security baseline — UI is never access authority.
 */
export const QXREAD_SECURITY_BASELINE = Object.freeze({
    uiIsNotAccessAuthority: true,
    sessionIsNotEntitlement: true,
    catalogIsNotContentAccess: true,
    entitlementVerifiesBeforeReaderLaunch: true,
    offlineRequiresEntitlement: true,
    qxpMutationForbidden: true,
    qxwMutationForbidden: true,
    readerRuntimeOwnedByQxreader: true,
    affiliateReferralAutomatic: true,
    affiliateReferralSellerConfigFree: true,
    affiliateNotPublicationTruth: true,
    referralNotPublicationTruth: true,
    ledgerConceptsRemainSeparate: true,
    affiliateRewardWithdrawable: true,
    referralRewardWithdrawable: true,
    rewardsAreBuyerFunded: true,
    sellerPriceDoesNotFundRewards: true,
    rewardNotImmediatelyAvailableAtCheckout: true,
    uiCannotMintOrMutateRewardBalance: true,
    withdrawalRequiresAuthoritativeLedger: true,
    catalogIsNotQxpAuthority: true,
    listingIsNotEntitlement: true,
    previewIsNotFullAccess: true,
    marketplaceIsNotCommerce: true,
    marketplaceIsNotReaderLaunch: true,
    bookCardIsNotPurchase: true,
});
/**
 * Rejects any attempt to weaken the frozen baseline via overrides.
 * Call sites pass Partial for intentional mutation attempts under test.
 */
export function assertSecurityBaselineIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_SECURITY_BASELINE)) {
        const expected = QXREAD_SECURITY_BASELINE[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead security baseline violated: ${key}`);
        }
    }
    return QXREAD_SECURITY_BASELINE;
}
//# sourceMappingURL=security-baseline.js.map